// tslint:disable
export var ContactInformationPurposeType;
(function (ContactInformationPurposeType) {
    // UNKN
    ContactInformationPurposeType[ContactInformationPurposeType["UNKN"] = 0] = "UNKN";
    // MAIN
    ContactInformationPurposeType[ContactInformationPurposeType["MAIN"] = 1] = "MAIN";
    // MKTG
    ContactInformationPurposeType[ContactInformationPurposeType["MKTG"] = 2] = "MKTG";
    // SALES
    ContactInformationPurposeType[ContactInformationPurposeType["SALES"] = 3] = "SALES";
    // CUSTSER
    ContactInformationPurposeType[ContactInformationPurposeType["CUSTSER"] = 4] = "CUSTSER";
    // HOME
    ContactInformationPurposeType[ContactInformationPurposeType["HOME"] = 5] = "HOME";
    // WORK
    ContactInformationPurposeType[ContactInformationPurposeType["WORK"] = 6] = "WORK";
    // SEAS
    ContactInformationPurposeType[ContactInformationPurposeType["SEAS"] = 7] = "SEAS";
    // OTHR
    ContactInformationPurposeType[ContactInformationPurposeType["OTHR"] = 8] = "OTHR";
})(ContactInformationPurposeType || (ContactInformationPurposeType = {}));
//# sourceMappingURL=ContactInformationPurposeType.js.map